/* global document, window */
'use strict';

import {getBaseUrl} from './utils';

const queryString = window.location.search.slice(1);
const debug = queryString && queryString.indexOf('v-few-frg-loader-debug=true') !== -1;

export default {
    // get few server base url from current <script> src (fallback to document.querySelector for IE)
    fewBaseUrl: getBaseUrl(document.currentScript || document.querySelector('script[src*="fragmentLoader.js"]')),
    // support fr, fr_CA, fr-CA formats
    lang: (document.documentElement.getAttribute('lang') || 'fr').toLowerCase().split('_')[0].split('-')[0],
    byType: {
        static: {
            order: 1
        },
        angularjs: {
            order: 2,
            singleBootstrap: false
        }
    },
    // wait for document ready before loading integration points
    waitForDocReady: false,
    // use to override few app config
    fragmentsConfigOverride: {},
    // log levels: debug, info, warn, error
    logLevel: debug ? 'debug' : 'info'
};
